import ws from '@api/webservice'
import config from '@app/config'

const api = {
  tutorials: () => ws<TutorialListResponse>(config.ws.help.tutorials, 'GET'),
}

export default api
